module.exports = ".gdpr-section {\n  border: 1px solid #ebebeb;\n  background: #f9f9f9;\n  padding: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/gdpr/enable-gdpr-section/enable-gdpr-section.scss
// module id = ./web/modern/components/settings/gdpr/enable-gdpr-section/enable-gdpr-section.scss
// module chunks = 0